function cdnFile(fileKey, force = false) {
  return `${import.meta.env.VITE_CDN_URL}/${import.meta.env.VITE_DEBUG && !force ? 'girl-bg.webp' : fileKey}`
}

export default cdnFile
